import { createTermoNotificacaoApi } from "@/contexts/fiscalizacao/termoNotificacao/api/termoNotificacaoApi";
import { TermoNotificacao } from "@/contexts/fiscalizacao/termoNotificacao/model/TermoNotificacao";
import {
  getTermosNotificacao,
  termoNotificacaoAction,
} from "@/contexts/fiscalizacao/termoNotificacao/store/termoNotificacaoSlice";
import { useAuth } from "react-oidc-context";
import { useDispatch, useSelector } from "react-redux";

export const useTermoNotificacao = () => {
  const { user } = useAuth();
  const appDispatch = useDispatch();
  const { add, remove, update } = termoNotificacaoAction;
  const listaTermosNotificacao = useSelector(getTermosNotificacao);
  const termoApi = createTermoNotificacaoApi(user?.access_token);

  const addTermoNotificacao = (item: TermoNotificacao) => {
    appDispatch(add(item));
  };

  const removeTermoNotificacao = (offlineId: number) => {
    appDispatch(remove(offlineId));
  };

  const updateTermoNotificacao = (item: TermoNotificacao) => {
    appDispatch(update(item));
  };

  const getTermosNotificacaoByOfflineId = (offlineId: number) => {
    return listaTermosNotificacao.find(
      (termo) => termo.offlineId === offlineId
    );
  };

  return {
    listaTermosNotificacao,
    addTermoNotificacao,
    removeTermoNotificacao,
    updateTermoNotificacao,
    getTermosNotificacaoByOfflineId,
    submitTermoNotificacaoApi: termoApi.submit,
    cancelarTermoNotificacaoApi: termoApi.cancelar,
    getTermoNotificacaoByIdApi: termoApi.getById,
    getTermosNotificacaoApi: termoApi.list,
    submitSaneamentoTermoNotificacaoApi: termoApi.submitSaneamento,
    submitParecerTermoNotificacaoApi: termoApi.submitParecer,
    getTermoNotificacaoSaneamentoApi: termoApi.getSaneamentos,
    getAnexoApi: termoApi.getAnexo,
  };
};
